export default __webpack_public_path__ + "static/media/ali.db49bf8f.jpg";